"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = void 0;
var _react = _interopRequireDefault(require("react"));
require("./Divider.css");
var _tokens = require("../tokens");
var _linaria = require("../utils/linaria");
var _Box = require("./Box");
const _excluded = ["color", "direction"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const styles = {
  line: "cds-line-ljohrkr",
  lineHeavy: "cds-lineHeavy-ljhkm0x",
  horizontal: "cds-horizontal-h1im6ndd",
  vertical: "cds-vertical-v19bzgvf"
};
const Divider = _ref => {
  let _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'line' : _ref$color,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'horizontal' : _ref$direction,
    boxProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    alignItems: "stretch",
    alignSelf: "stretch"
  }, boxProps), /*#__PURE__*/_react.default.createElement("div", {
    "aria-orientation": direction,
    className: (0, _linaria.cx)(styles[direction], styles[color]),
    role: "separator"
  }));
};
exports.Divider = Divider;